import { ComplianceRepository } from "../../repositories/ComplianceRepository";
import { MasterComplianceCalendarEntity } from "../../entities/MasterComplianceCalendarEntity";

export class UpdateCalendarEntryUseCase {
  constructor(private repository: ComplianceRepository) {}

  async execute(id: number, data: Partial<MasterComplianceCalendarEntity>): Promise<MasterComplianceCalendarEntity> {
    if (!id) {
      throw new Error("Calendar entry ID is required");
    }

    return await this.repository.updateCalendarEntry(id, data);
  }
}

